import axiosInstance from "shared/axios";
import { TRANSACTION_API } from "shared/constants";
import { COLLECTION_API } from "../constants";

const UPLOAD_URI = {
  listing: "/api/v1/bulk-upload/file/list",
  status: "/api/v1/bulk-upload",
};

export const uploadListing = (data = {}) => {
  return axiosInstance.post(UPLOAD_URI.listing, data);
};

export const uploadStatus = (upload_ref_no) => {
  return axiosInstance.get(`${UPLOAD_URI.status}/${upload_ref_no}/stats`);
};
export const downloadFile = (upload_ref_no) => {
  return axiosInstance.get(
    `${UPLOAD_URI.status}/${upload_ref_no}/response-file`
  );
};

export const interruptFileUpload = (upload_ref_no) => {
  return axiosInstance.post(`${UPLOAD_URI.status}/${upload_ref_no}/interrupt`, {
    _method: "patch",
  });
};

export const softDeleteUpload = (formdata) => {
  return axiosInstance.post(
    `${TRANSACTION_API.listing}/soft-delete`,
    formdata,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
};
export const lowPrioritySmBlockedupload = (param) => {
  return axiosInstance.post(
    `${COLLECTION_API.listing}/low-priority-bulk-upload`,
    param
  );
};
